import React from 'react';
import FlowStatusLayout from '~/client/components/flow-status-layout/flow-status-layout';
import type { BootCampShopStatus as Props } from './boot-camp-shop-status.types';

const BootCampShopStatus: React.FC<Props> = props => (
  <FlowStatusLayout {...props} />
);

export default BootCampShopStatus;
